export default "__VITE_ASSET__CqzYRoZg__"